import React from 'react';
import PropTypes from 'prop-types';
import { PDP_CUSTOMIZE_TAB_ID, PDP_READYTOSHIP_TAB_ID, PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import ImportantToggle from 'components/consumer/ImportantToggle';
import useSetPdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import { PRODUCT_CONFIGURATION_INTERACTION, trackProductConfigurationInteracted } from 'data-hooks/useEvents/pdpInteractionEvents';
import { customItem, readyToShipItem, decideLaterItem } from './itemContent';
const SELECTED_INTERACTION_BY_TAB = {
  [PDP_CUSTOMIZE_TAB_ID]: PRODUCT_CONFIGURATION_INTERACTION.CUSTOMIZATION_SELECTED,
  [PDP_READYTOSHIP_TAB_ID]: PRODUCT_CONFIGURATION_INTERACTION.READY_TO_SHIP_SELECTED,
  [PDP_DECIDELATER_TAB_ID]: PRODUCT_CONFIGURATION_INTERACTION.DECIDE_LATER_SELECTED
};
const getValidTabItems = conditions => {
  let finalItems = [customItem];
  const {
    showReadyToShip,
    isEFGInternal,
    showDecideLater,
    isLayoutRevamp
  } = conditions;
  if (!isEFGInternal) {
    if (showReadyToShip) {
      finalItems.push(readyToShipItem);
    } else if (isLayoutRevamp) {
      // The revamp rail always shows both tabs
      finalItems.push({
        ...readyToShipItem,
        disabled: true
      });
    }
    if (showDecideLater) {
      finalItems.push(decideLaterItem);
    }
  } else if (showReadyToShip && isEFGInternal) {
    finalItems = [readyToShipItem];
  }
  return finalItems;
};
const PDPShopTabsBarUI = ({
  hideShopsTabBar = false,
  isEFGInternal = false,
  loading = false,
  price,
  showDecideLater = false,
  showReadyToShip = true,
  isLayoutRevamp = false
}) => {
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  decideLaterItem.description = price?.max_discount_percent ? `Lock in up to ${price.max_discount_percent}% off` : price?.discount_percent ? `Lock in ${price.discount_percent}% off` : `Buy now, decide later`;
  const items = getValidTabItems({
    showReadyToShip,
    isEFGInternal,
    showDecideLater,
    isLayoutRevamp
  }).map(item => isLayoutRevamp && item === customItem ? {
    ...item,
    label: 'Customization'
  } : item);

  // Tracked here, not in the setter: effects also switch tabs on their own
  const selectTab = tabId => {
    const isNewTab = tabId !== pdpSelectedCustomizerTab;
    setPdpSelectedCustomizerTab(tabId);
    if (isNewTab) {
      trackProductConfigurationInteracted(SELECTED_INTERACTION_BY_TAB[tabId]);
    }
  };
  if (hideShopsTabBar) {
    return <div className="PDPShopTabsBarUI__filler" />;
  }
  return <div className="PDPShopTabsBarUI" data-xc="PDPShopTabsBarUI">
      <ImportantToggle items={items} selected={pdpSelectedCustomizerTab} loading={loading} onClick={selectTab} aria-label="Product Option Types" isLayoutRevamp={isLayoutRevamp} />
    </div>;
};
PDPShopTabsBarUI.propTypes = {
  hideShopsTabBar: PropTypes.bool,
  isEFGInternal: PropTypes.bool,
  loading: PropTypes.bool,
  price: PropTypes.shape({
    discount_percent: PropTypes.number,
    max_discount_percent: PropTypes.number
  }),
  showDecideLater: PropTypes.bool,
  showReadyToShip: PropTypes.bool,
  isLayoutRevamp: PropTypes.bool
};
export default PDPShopTabsBarUI;